module.exports = __webpack_public_path__ + "static/blockchain-22958f268e3c824aaa178e29f4a936b4.png";